import http from "./../shared/axios";
import EncrDecrService from "../services/EncrDecrService.Service";
import { Otp_Gen } from "../shared/ServiceCommonEndpoints";
class OtpService {
  funcGenerateOtp(payload, reasonCode) {
    const otpInputData = {
      reasonCode: reasonCode,
      resendRequest: "true",
      orgId: "101",
      regenerationFlag: "true",
    };
    let encyIdentifier = "";
    if(payload.mobileNo){
      otpInputData.mobileNumber = payload.mobileNo;
      encyIdentifier = EncrDecrService.set(payload.mobileNo)
    }else if(payload.emailId){
      otpInputData.emailId = payload.emailId;
      encyIdentifier = EncrDecrService.set(payload.emailId)
    }else if(payload.officialEmail){
      otpInputData.emailId = payload.officialEmail;
      encyIdentifier = EncrDecrService.set(payload.officialEmail)
    }
    return http.post(Otp_Gen, otpInputData,
      {
        headers: {
          "IDENTIFIER_1": encyIdentifier,
          "IDENTIFIER_2": localStorage.getItem("visitorID"),
          "ENCRYPTED_ID": "1"
        }
      });
  }
}
// eslint-disable-next-line
export default new OtpService();
